import { render, staticRenderFns } from "./FieldEditor.vue?vue&type=template&id=2e38d951&scoped=true&"
import script from "./FieldEditor.vue?vue&type=script&lang=js&"
export * from "./FieldEditor.vue?vue&type=script&lang=js&"
import style0 from "./FieldEditor.vue?vue&type=style&index=0&id=2e38d951&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38d951",
  null
  
)

export default component.exports